import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import DailyEntry from "@/pages/DailyEntry";
import StockView from "@/pages/StockView";
import History from "@/pages/History";
import LoginPage from "@/pages/LoginPage";
import PrintReport from "@/pages/PrintReport";
import AdminPanel from "@/pages/AdminPanel";
import UserSettings from "@/pages/UserSettings";
import Worksheet from "@/pages/Worksheet";
import Schedule from "@/pages/Schedule";
import Coupon from "@/pages/Coupon";
import LVM from "@/pages/LVM";
import LVMPrint from "@/pages/LVMPrint";
import PinReset from "@/pages/PinReset";
import StorePaperwork from "@/pages/StorePaperwork";
import LottoScan from "@/pages/LottoScan";
import ExportReports from "@/pages/ExportReports";
import { PinLockGate } from "@/components/PinLockGate";
import { FeatureGate } from "@/components/FeatureGate";
import { FeatureAccessGate } from "@/components/FeatureAccessGate";
import FunTime from "@/pages/FunTime";
import { RouteErrorBoundary } from "@/components/RouteErrorBoundary";

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground antialiased selection:bg-primary/20">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/pin-reset/:token" element={<PinReset />} />
            <Route path="/print/:type/:date" element={<PrintReport />} />
            <Route path="/print-lvm/:date" element={<LVMPrint />} />
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="entry" element={<DailyEntry />} />
              <Route path="entry/:date" element={<DailyEntry />} />
              <Route path="stock" element={<StockView />} />
              <Route path="history" element={<History />} />
              <Route path="admin" element={<AdminPanel />} />
              <Route path="settings" element={<UserSettings />} />
              <Route path="worksheet" element={<Worksheet />} />
              <Route path="lotto-scan" element={<FeatureAccessGate feature="lotto_scan"><LottoScan /></FeatureAccessGate>} />
              <Route path="schedule" element={<Schedule />} />
              <Route path="coupon" element={<Coupon />} />
              <Route path="lvm" element={<PinLockGate label="LVM"><LVM /></PinLockGate>} />
              <Route path="lvm/:date" element={<PinLockGate label="LVM"><LVM /></PinLockGate>} />
              <Route path="store-paperwork" element={<FeatureGate flag="store_paperwork_enabled"><RouteErrorBoundary><StorePaperwork /></RouteErrorBoundary></FeatureGate>} />
              <Route path="store-paperwork/:date" element={<FeatureGate flag="store_paperwork_enabled"><RouteErrorBoundary><StorePaperwork /></RouteErrorBoundary></FeatureGate>} />
              <Route path="exports" element={<RouteErrorBoundary><ExportReports /></RouteErrorBoundary>} />
              <Route path="fun-time" element={<FeatureAccessGate feature="fun_time"><FunTime /></FeatureAccessGate>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
